export enum WasteType {
  GL = '0',
  RTS = '1',
  Cloud = '2'
}

export const wasteTypes = Object.keys(WasteType)
  .filter(key => isNaN(Number(key)))
  .map(key => ({ key: WasteType[key as keyof typeof WasteType], value: key }));